import { FC } from 'react';

import Table from 'modules/_shared/Table';

import PartnerSharesTableHeader from './PartnerSharesTableHeader';
import PartnerSharesTableBody from './PartnerSharesTableBody';

const PartnerSharesTable: FC = () => {
  const tableContent = (
    <>
      <PartnerSharesTableHeader />
      <PartnerSharesTableBody />
    </>
  );

  return <Table content={tableContent} />;
};

export default PartnerSharesTable;
